class MainController {
  constructor() {
    this.name = 'main';
  }
}

export default MainController;



// WEBPACK FOOTER //
// ./client/app/components/main/main.controller.js